import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AchDetailsApiResponse } from '../models/ach-details-response.model'
import { ACH_TRANSACTION_DETAILS_CONFIG } from '../models/ach-config.model'

@Injectable({ providedIn: 'root' })
export class TransactionDetailsApiService {
    private readonly http = inject(HttpClient)
    private readonly config = inject(ACH_TRANSACTION_DETAILS_CONFIG)

    private get baseUrl(): string {
        const base = this.config.bffBaseUrl.replace(/\/+$/, '')
        return `${base}/api/v1/ach-details`
    }

    getTransactionDetails(transactionId: string, sessionId: string): Observable<AchDetailsApiResponse> {
        return this.http.get<AchDetailsApiResponse>(
            `${this.baseUrl}/${transactionId}`,
            { headers: this.buildHeaders(sessionId) }
        )
    }

    logExport(transactionId: string, sessionId: string): Observable<void> {
        return this.http.post<void>(
            `${this.baseUrl}/${transactionId}/exports`,
            {},
            { headers: this.buildHeaders(sessionId) }
        )
    }

    downloadPdf(transactionId: string, sessionId: string): Observable<Blob> {
        return this.http.get(
            `${this.baseUrl}/${transactionId}/pdf`,
            { headers: this.buildHeaders(sessionId), responseType: 'blob' }
        )
    }

    private buildHeaders(sessionId: string): HttpHeaders {
        return new HttpHeaders({ 'X-Session-ID': sessionId })
    }
}
